<template>
  <div style="padding:15px;">

    <el-form ref="form" :model="queryForm" :inline="true" >
      <el-form-item label="姓名">
        <el-input v-model="queryForm.keyword" clearable placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
          查询
        </el-button>
        <el-button  type="primary" native-type="submit" @click="edit(null)" >
          添加纸箱
        </el-button>
      </el-form-item>
    </el-form>
    <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
      height="75vh" border>
      <el-table-column show-overflow-tooltip prop="name" label="标题" align="center" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip prop="phone" label="类型" align="center">
        <template #default="{ row }">
          <span v-if="row.type==1" >纸箱</span>
          <span v-if="row.type==2" >快递袋</span>
          <span v-if="row.type==3" >物品加固</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="创建时间" prop="add_time" min-width="120" sortable
        align="center"></el-table-column>
      <el-table-column show-overflow-tooltip label="操作面板" width="150px" fixed="right" align="center">
        <template #default="{ row }">
          <el-button type="text" @click="edit(row)">详情</el-button>
          <el-button type="text" style="color: red;" @click="del_item(row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="queryForm.page" :layout="layout" :page-size="queryForm.limit" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
    <Add @formChange="fetchData()" ref="add"></Add>
  </div>
</template>

<script>
  import Add from './add.vue'
  import { baseURL_print, getUploadUrl } from '@/config'
  import {
    MonadCarton_update, //新用户添加修改
    MonadCarton_detail, //详情
    MonadCarton_del, //删除
    MonadCarton_list, //列表
  } from '@/api/new_user.js'
  import {
    uploadFileZdh
  } from '@/api/xgcApi'
  export default {
    components: {
      Add
    },
    data() {
      return {
        uploadFileUrl: baseURL_print + 'index/index/file',
        listLoading: true,
        elementLoadingText: '加载中...',
        list: [],
        total: 0,
        layout: 'total, sizes, prev, pager, next, jumper',
        queryForm: {
          page: 1,
          limit: 20,
          "keyword": ""
        }
      }
    },
    created() {},
    beforeDestroy() {},
    mounted() {
      this.fetchData()
    },
    methods: {
      async handleChange(file, fileList) {
        // 导入
        if (file.response != undefined) {
          var strurl = file.response
          strurl = strurl.replace(/\\/g, '/')
          const { code, data, msg } = await Monad_excel_add({
            file: strurl,
          })
          if (code == 200) {
            this.$message({
              type: 'success',
              message: '导入成功',
            })
            this.fetchData()
          } else {
            this.$baseMessage('失败')
            return false
          }
        }
      },
      del_item(row){
        // 删除用户
         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            MonadCarton_del({id:row.id}).then(res=>{
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.fetchData()
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      edit(row){
        this.$refs['add'].showEdit(row)
      },
      handleQuery() {
        this.queryForm.page = 1
        this.fetchData()
      },
      fetchData() {
        var data = {
          ...this.queryForm
        }
        MonadCarton_list(data).then(res => {
          this.listLoading = false
          this.total = res.data.count
          this.list = res.data.list
        })
      },
      handleSizeChange(e) {
        this.queryForm.limit = e
        this.queryForm.page = 1
        this.fetchData()
      },
      handleCurrentChange() {
        this.queryForm.page = e
        this.fetchData()
      }
    },
  }
</script>

<style>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }
</style>
